import { WebsiteLoginActions } from './website-login-actions'
import {
  CHANGE_WEBSITE_LOGIN_MODE,
  WebsiteLoginModeEnum,
} from './website-login-types'

export interface WebsiteLoginState {
  websiteLoginMode: WebsiteLoginModeEnum
}

export default function websiteLoginReducer(
  state: WebsiteLoginState = { websiteLoginMode: WebsiteLoginModeEnum.Login },
  action: WebsiteLoginActions,
) {
  switch (action.type) {
    case CHANGE_WEBSITE_LOGIN_MODE:
      return {
        ...state,
        websiteLoginMode: action.payload,
      }
    default:
      return state
  }
}

function getWebsiteLoginMode(state: WebsiteLoginState) {
  return state.websiteLoginMode
}

export const selectors = {
  getWebsiteLoginMode,
}
